const BYTE_MULTIPLIER = 1;
const KIBIBYTE_MULTIPLIER = 1024;
const MEBIBYTE_MULTIPLIER = KIBIBYTE_MULTIPLIER * KIBIBYTE_MULTIPLIER;
const GIBIBYTE_MULTIPLIER = MEBIBYTE_MULTIPLIER * KIBIBYTE_MULTIPLIER;
const TEBIBYTE_MULTIPLIER = GIBIBYTE_MULTIPLIER * KIBIBYTE_MULTIPLIER;
export const DATA_UNITS = ["B", "MB", "GB", "TB"];
export const DATA_UNITS_DISPLAY = ["MB", "GB"];

export function convert(amount, from, to) {
  if (from === to) return amount;
  return Math.round(convertExact(amount, from, to) * 100) / 100;
}

export function convertExact(amount, from, to) {
  if (!amount) return amount;
  if (from === to) return amount;
  let fromMultiplier = getMultiplier(from);
  let toMultiplier = getMultiplier(to);
  if (fromMultiplier === 0 || toMultiplier === 0) return null;
  let amountMultiplier = fromMultiplier / toMultiplier;
  return amount * amountMultiplier;
}

export function convertBytes(bytes) {
  if (!bytes) return "-";
  else if (bytes < 1048576) {
    return bytes + "B";
  } else if (bytes < 1073741824) {
    return convert(bytes, "B", "MB") + "MB";
  } else if (bytes < 1099510000000) {
    return convert(bytes, "B", "GB") + "GB";
  } else {
    return convert(bytes, "B", "TB") + "TB";
  }
}

function getMultiplier(unit) {
  switch (unit) {
    case "B":
      return BYTE_MULTIPLIER;
    case "KB":
      return KIBIBYTE_MULTIPLIER;
    case "MB":
      return MEBIBYTE_MULTIPLIER;
    case "GB":
      return GIBIBYTE_MULTIPLIER;
    case "TB":
      return TEBIBYTE_MULTIPLIER;
    default: {
      console.log("No such Unit");
      return 0;
    }
  }
}
